<template>
    <div class="row" v-loading="isLoading">
        <div class="form-group col-6">
            <label class="mb-0" :for="'profile' + _uid">Анкета заявки</label>
            <ProfileSelect v-model="profile_id" :request_id="deal.request_id" :id="'profile' + _uid"/>
            <div v-if="field_errors.hasOwnProperty('profile_id')" class="help-block invalid-feedback d-block" v-html="field_errors['profile_id'][0]"/>
        </div>
        <div class="form-group col-6">
            <label class="mb-0" :for="'salon_legal_entity_id' + _uid">Юрлицо площадки</label>
            <CounteragentSelect v-model="salon_legal_entity_id" :filter_type="'company'" class="multiselect-bootstrap" :id="'salon_legal_entity_id' + _uid"/>
            <div v-if="field_errors.hasOwnProperty('salon_legal_entity_id')" class="help-block invalid-feedback d-block" v-html="field_errors['salon_legal_entity_id'][0]"/>
        </div>
        <div class="form-group col-12 text-right">
            <button @click="generate" class="btn btn-light"><i class="fas fa-download mr-2"></i>Скачать документ</button>
        </div>
    </div>
</template>

<script>
import CounteragentSelect from "../../counteragents/CounteragentSelect";
import ProfileSelect from "../../requests/profiles/ProfileSelect";
import formMixin from "../formMixin";
import _ from "lodash";

export default {
    name: "APP_TS",
    mixins: [formMixin],
    components: {CounteragentSelect, ProfileSelect},
    props: {
        deal: {
            type: Object,
            required: true,
        },
        form_name: {
            type: String,
            required: true,
        },
        condition: {
            type: String,
            required: true,
        },
        in_credit: {
            type: Boolean,
            required: true,
        }
    },
    data: () => ({
        isLoading: false,
        profile_id: null,
        salon_legal_entity_id: null,
        field_errors: {},
    }),
    computed: {
        form_params() {
            return {
                form_name: this.form_name,
                deal_id: this.deal.id,
                profile_id: this.profile_id,
                salon_legal_entity_id: this.salon_legal_entity_id,
            };
        }
    }
}
</script>

<style scoped>

</style>
